module.exports = __webpack_public_path__ + "img/sony_laptop-prices-in-India.31d71532.jpg";